import { ReactComponent as Category } from '../../assets/icon/category.svg';
import { ReactComponent as CursorRight } from '../../assets/icon/cursor_right.svg';
import { ReactComponent as Guide } from '../../assets/icon/guide.svg';
import { ReactComponent as MenuIcon } from '../../assets/icon/menu.svg';
import { ReactComponent as Scene } from '../../assets/icon/scene.svg';
import { Link } from '../Link.client';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import { Menu } from '@headlessui/react';
import { useUrl } from '@shopify/hydrogen';
import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';
import { mainCategories } from '../../constants/Categories';
import { scenes } from '../../constants/Scenes';
import { MobileMenu } from './MobileMenu.client';

interface Props {
  isLogin: boolean;
}

export const MobileNavigation: FC<Props> = ({ isLogin }) => {
  const url = useUrl();
  const [openMenu, setOpenMenu] = useState(false);
  const [openCategories, setOpenCategories] = useState(false);
  const [openScenes, setOpenScenes] = useState(false);

  const onOpen = (target: 'menu' | 'categories' | 'scene') => {
    close();
    switch (target) {
      case 'categories':
        setOpenCategories(!openCategories);
        break;
      case 'menu':
        setOpenMenu(!openMenu);
        break;
      case 'scene':
        setOpenScenes(!openScenes);
        break;
    }
  };

  const close = () => {
    setOpenCategories(false);
    setOpenMenu(false);
    setOpenScenes(false);
  };

  useEffect(() => {
    close();
  }, [url]);

  return (
    <nav className="border-t border-lightGray">
      <div className="text-xs font-semibold">
        <ul className="relative grid grid-cols-3">
          <li>
            <Menu as="div">
              <Menu.Button
                className={clsx(
                  'flex w-full cursor-pointer flex-col items-center py-2',
                  openCategories && 'bg-dark text-white',
                )}
                onClick={() => onOpen('categories')}
              >
                {openCategories ? (
                  <Category width={20} fill="white" />
                ) : (
                  <Category width={20} fill="#222" />
                )}
                <a className="mt-1">カテゴリー</a>
              </Menu.Button>
              <CategoriesMenu />
            </Menu>
          </li>
          <li>
            <Menu as="div">
              <Menu.Button
                className={clsx(
                  'flex w-full cursor-pointer flex-col items-center py-2',
                  openScenes && 'bg-dark text-white',
                )}
                onClick={() => onOpen('scene')}
              >
                {openScenes ? <Scene width={20} fill="white" /> : <Scene width={20} fill="#222" />}
                <a className="mt-1">シーンで探す</a>
              </Menu.Button>
              <ScenesMenu />
            </Menu>
          </li>
          {/* <li>
            <Link route="categories" className="flex flex-col items-center py-2">
              <PhotoGoods width={20} />
              <p className="mt-1">写真・名入れ</p>
            </Link>
          </li> */}
          <li>
            <Menu as="div">
              <Menu.Button
                className={clsx(
                  'flex w-full cursor-pointer flex-col items-center py-2',
                  openMenu && 'bg-dark text-white',
                )}
                onClick={() => onOpen('menu')}
              >
                {openMenu ? (
                  <MenuIcon width={20} fill="white" />
                ) : (
                  <MenuIcon width={20} fill="#222" />
                )}
                <a className="mt-1">メニュー</a>
              </Menu.Button>
              <MobileMenu isLogin={isLogin} />
            </Menu>
          </li>
        </ul>
      </div>
    </nav>
  );
};

const CategoriesMenu = () => (
  <Menu.Items className="absolute right-0 z-50 max-h-[calc(100vh-142px)] w-screen origin-top-right flex-col overflow-y-scroll bg-[#222] px-2 pt-5 pb-9 focus:outline-none">
    {/* <div className="mb-5 grid grid-cols-2 gap-2">
      <Menu.Item>
        <Link route="login">
          <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
            <Photogoods width={24} height={24} fill="white" />
            <p className="text-[15px] text-white">写真グッズ</p>
          </div>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link route="register">
          <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
            <Naire width={24} height={24} fill="white" />
            <p className="text-[15px] text-white">名入れグッズ</p>
          </div>
        </Link>
      </Menu.Item>
    </div>
    <div className="mb-5">
      <Menu.Item>
        <Link route="ordermade">
          <div className="flex items-center justify-center gap-2">
            <p className="text-[15px] text-white">オーダー商品の作り方</p>
            <CursorRight width={12} height={12} fill="white" />
          </div>
        </Link>
      </Menu.Item>
    </div> */}
    <div className="mb-5 flex flex-col gap-[1px]">
      {mainCategories.map((category, index) => (
        <Menu.Item key={index}>
          <Link route="category" handle={category}>
            <div className="flex justify-between bg-white p-3">
              <p className="text-[15px]">{category}</p>
              <CursorRight fill="black" width={12} height={12} />
            </div>
          </Link>
        </Menu.Item>
      ))}
      <Menu.Item>
        <Link route="products">
          <div className="flex justify-between bg-white p-3">
            <p className="text-[15px]">全ての商品</p>
            <CursorRight fill="black" width={12} height={12} />
          </div>
        </Link>
      </Menu.Item>
    </div>
    <div>
      <Menu.Item>
        <Link route="guides">
          <div className="flex items-center justify-center gap-1 rounded-full bg-white py-1">
            <Guide width={18} height={18} />
            <p className="text-sm font-bold text-dark">ご利用ガイド</p>
          </div>
        </Link>
      </Menu.Item>
    </div>
  </Menu.Items>
);

const ScenesMenu = () => (
  <Menu.Items className="absolute right-0 z-50 max-h-[calc(100vh-142px)] w-screen origin-top-right flex-col overflow-y-scroll bg-[#222] px-2 pt-5 pb-9 focus:outline-none">
    {/* <div className="mb-5 grid grid-cols-2 gap-2">
      <Menu.Item>
        <Link route="login">
          <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
            <Photogoods width={24} height={24} fill="white" />
            <p className="text-[15px] text-white">写真グッズ</p>
          </div>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link route="register">
          <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
            <Naire width={24} height={24} fill="white" />
            <p className="text-[15px] text-white">名入れグッズ</p>
          </div>
        </Link>
      </Menu.Item>
    </div>
    <div className="mb-5">
      <Menu.Item>
        <Link route="ordermade">
          <div className="flex items-center justify-center gap-2">
            <p className="text-[15px] text-white">オーダー商品の作り方</p>
            <CursorRight width={12} height={12} fill="white" />
          </div>
        </Link>
      </Menu.Item>
    </div> */}
    <div className="mb-5 flex flex-col gap-[1px]">
      {scenes.map((scene, index) => (
        <Menu.Item key={index}>
          <Link route="scene" handle={scene}>
            <div className="flex justify-between bg-white p-3">
              <p className="text-[15px]">{scene}</p>
              <CursorRight fill="black" width={12} height={12} />
            </div>
          </Link>
        </Menu.Item>
      ))}
      <Menu.Item>
        <Link route="products">
          <div className="flex justify-between bg-white p-3">
            <p className="text-[15px]">全ての商品</p>
            <CursorRight fill="black" width={12} height={12} />
          </div>
        </Link>
      </Menu.Item>
    </div>
    <div>
      <Menu.Item>
        <Link route="guides">
          <div className="flex items-center justify-center gap-1 rounded-full bg-white py-1">
            <Guide width={18} height={18} />
            <p className="text-sm font-bold text-dark">ご利用ガイド</p>
          </div>
        </Link>
      </Menu.Item>
    </div>
  </Menu.Items>
);
